import * as moment from "moment";
import { parseLocaleDecimal } from "../app/helper";

export enum Direction {
  Soll = "S",
  Haben = "H"
}
export function invertDirection(d: Direction) {
  return d === Direction.Haben ? Direction.Soll : Direction.Haben;
}

export enum ExtCols {
  LABEL = "Buchungstext",
  AMOUNT = "Umsatz (ohne Soll-/ Haben-Kennzeichen)",
  DIRECTION = "Soll-/Haben-Kennzeichen",
  SOURCE_ACCOUNT_NUMBER = "Konto",
  CONTRA_ACCOUNT_NUMBER = "Gegenkonto (ohne BU-Schlüssel)",
  DATE = "Belegdatum",
  COST_CENTER_1 = "KOST1 - Kostenstelle"
}
export const AlternativeColNames = {
  "Umsatz (ohne Soll/Haben-Kz)": ExtCols.AMOUNT,
  "Soll/Haben-Kennzeichen": ExtCols.DIRECTION,
  "Soll-/Haben-Kennzeichen ": ExtCols.DIRECTION
};
export type RawExtfLine = { [x in ExtCols]: string };

export interface AccountMovementMeta {
  lineNumber: number;
}

export interface AccountMovement {
  readonly label: string;
  readonly amount: number;
  readonly costCenter1: string;
  readonly date: Date;
  readonly contraAccountNumber: number;
  readonly sourceAccountNumber: number;
  readonly direction: Direction;
  // readonly meta: AccountMovementMeta;
}
export function parseDatevLine(rawData: RawExtfLine): AccountMovement {
  Object.entries(AlternativeColNames).forEach(([name, col]) => {
    if (rawData[name] !== undefined) {
      rawData[col] = rawData[name];
      delete rawData[name];
    }
  });

  return {
    label: rawData[ExtCols.LABEL],
    amount: parseLocaleDecimal(rawData[ExtCols.AMOUNT]),
    direction: rawData[ExtCols.DIRECTION] as Direction,
    sourceAccountNumber: +rawData[ExtCols.SOURCE_ACCOUNT_NUMBER],
    contraAccountNumber: +rawData[ExtCols.CONTRA_ACCOUNT_NUMBER],
    date: moment(rawData[ExtCols.DATE], "DDMM").toDate(),
    costCenter1: rawData[ExtCols.COST_CENTER_1]
    // meta: metaData
  };
}



// WEBPACK FOOTER //
// ./src/db/AccountMovement.ts